// @ts-nocheck
/**
 * TNF Cart Drawer — Quantity & Remove click handlers + free-shipping promo detection.
 * Dispatches 'quantity-selector:update' events that CartItemsComponent
 * (component-cart-items.js) already listens for and handles via AJAX + morphSection.
 *
 * Free-shipping detection strategy:
 *   1. Liquid already strips the thermometer when a shipping discount_application is found.
 *   2. This JS layer covers shipping-zone free rates (not in discount_applications):
 *      - Fetches /cart/async_shipping_rates.json to check if any rate costs $0.
 *      - Falls back to /cart.js discount_applications check as primary signal.
 *      - Re-runs on every cart:update and discount:update event.
 */
(function () {
  'use strict';

  // ─── Free-shipping thermometer detection ─────────────────────────────────────

  /**
   * Hide [data-tnf-thermometer] elements that Liquid may have left in the DOM
   * because it couldn't detect the shipping promo (e.g. shipping-zone free rate).
   */
  function hideThermometers() {
    document.querySelectorAll('[data-tnf-thermometer]').forEach(function (el) {
      if (el.getAttribute('data-tnf-threshold-met') === 'true') {
        el.hidden = false;
        return;
      }

      el.hidden = true;
    });
  }

  function getShopDomain() {
    var shopify = window.Shopify;
    if (shopify && typeof shopify.shop === 'string' && shopify.shop) {
      return shopify.shop;
    }

    return document.documentElement.getAttribute('data-shop-domain') || '';
  }

  function cartHasAdminFreeShippingCampaign() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var params = new URLSearchParams();
        params.set('item_count', String(cart && cart.item_count ? cart.item_count : 0));
        params.set('cart_total_subunits', String(cart && cart.total_price ? cart.total_price : 0));

        var shop = getShopDomain();
        if (shop) {
          params.set('shop', shop);
        }

        params.set('mode', 'free_shipping_status');

        return fetch('/apps/discounts?' + params.toString(), {
          credentials: 'same-origin'
        });
      })
      .then(function (response) {
        if (!response.ok) return false;
        return response.json();
      })
      .then(function (payload) {
        return Boolean(payload && payload.hasFreeShippingCampaign);
      })
      .catch(function () { return false; });
  }

  /**
   * Check /cart.js for shipping discount_applications.
   * Returns a Promise<boolean>.
   */
  function cartHasShippingDiscount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var apps = [];

        if (Array.isArray(cart.discount_applications)) {
          apps = apps.concat(cart.discount_applications);
        }

        if (Array.isArray(cart.cart_level_discount_applications)) {
          apps = apps.concat(cart.cart_level_discount_applications);
        }

        return apps.some(function (d) {
          return d.target_type === 'shipping_line';
        });
      })
      .catch(function () { return false; });
  }

  /**
   * Check /cart/async_shipping_rates.json for a $0 rate.
   * Shopify only returns rates when the customer has a saved address or a default
   * address is present. Returns Promise<boolean>.
   */
  function shippingRatesAreFree() {
    return fetch('/cart/async_shipping_rates.json', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) return false;
        return r.json();
      })
      .then(function (data) {
        if (!data || !data.shipping_rates) return false;
        return data.shipping_rates.some(function (rate) {
          return Number(rate.price) === 0;
        });
      })
      .catch(function () { return false; });
  }

  /**
   * Run both checks in parallel. If either returns true, hide the thermometer.
   */
  function checkAndHideThermometer() {
    Promise.all([cartHasShippingDiscount(), shippingRatesAreFree(), cartHasAdminFreeShippingCampaign()])
      .then(function (results) {
        if (results[0] || results[1] || results[2]) {
          hideThermometers();
        }
      });
  }

  // Run on initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndHideThermometer);
  } else {
    checkAndHideThermometer();
  }

  // Re-run on every cart or discount update.
  // NOTE: cart:update fires BEFORE morphSection updates the DOM, so we defer
  // with setTimeout to ensure the new [data-tnf-thermometer] element is present.
  function deferredCheck() {
    setTimeout(checkAndHideThermometer, 0);
  }
  document.addEventListener('cart:update', deferredCheck);
  document.addEventListener('discount:update', deferredCheck);

  // ─── End free-shipping detection ─────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var target = /** @type {HTMLElement} */ (e.target);

    var plusBtn = target.closest('[data-tnf-qty-plus]');
    if (plusBtn) {
      e.preventDefault();
      var line = parseInt(plusBtn.getAttribute('data-line') || '0', 10);
      var qty = parseInt(plusBtn.getAttribute('data-qty') || '1', 10);
      dispatchQuantityUpdate(qty + 1, line);
      return;
    }

    var minusBtn = target.closest('[data-tnf-qty-minus]');
    if (minusBtn) {
      e.preventDefault();
      var line2 = parseInt(minusBtn.getAttribute('data-line') || '0', 10);
      var qty2 = parseInt(minusBtn.getAttribute('data-qty') || '1', 10);
      dispatchQuantityUpdate(Math.max(qty2 - 1, 0), line2);
      return;
    }

    var removeBtn = target.closest('[data-tnf-remove]');
    if (removeBtn) {
      e.preventDefault();
      var line3 = parseInt(removeBtn.getAttribute('data-line') || '0', 10);
      dispatchQuantityUpdate(0, line3);
      return;
    }
  });

  /**
   * Dispatch the quantity-selector:update event that CartItemsComponent handles.
   * @param {number} quantity - New quantity (0 = remove)
   * @param {number} cartLine - 1-indexed cart line number
   */
  function dispatchQuantityUpdate(quantity, cartLine) {
    var event = new CustomEvent('quantity-selector:update', {
      bubbles: true,
      detail: { quantity: quantity, cartLine: cartLine }
    });
    document.dispatchEvent(event);
  }
})();
